import styled from "styled-components";

export const Categories = styled.div`
    margin-left: 2em;
    margin-right: 2em;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
`

export const EbeneH3 = styled.h3`
    margin: 0;
    margin-top: 1em;
    width: 12em;
`

export const EbeneInhalt = styled.button`
    width: 18em;
    border-right: 1px solid lightslategrey;
    padding: 0.5em 1em;
    border: none;
    text-align: left;
    color: ${props => props.color};
    background-color: ${props => props.chosen ? "lightseagreen" : "none"}
`

export const TableOptionsAndView = styled.section `
    display: flex;
    flex-direction: row;
`

export const SpecificTable = styled.section `
    padding: 2em 1em;
    // border: 1px solid lightseagreen;
    flex-grow: 1;
    margin-right: 2em;
`